<div class="flex flex-col">
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        {{ 'housekeeping.monthlyConcepts' | transloco }}
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    @if (totalByNet4Concepts.value()?.length > 0) {
        <button class="self-end mr-4 mt-4" mat-icon-button (click)="printElement()" [matTooltip]="'housekeeping.printMonthlyConcepts' | transloco">
            <mat-icon [svgIcon]="'mat_outline:print'"></mat-icon>
        </button>
    }
    
    <div id="printableContent" class="flex flex-col w-full p-8 pb-16">
        <p class="text-2xl tracking-wide leading-relaxed mb-4 hidden">{{ date() | localizeDate: 'MMMM yyyy' | titlecase }} - {{ premises()?.premisesCode ?? premisesCode() }}</p>
        <div class="flex w-full">
            <div class="border border-primary text-primary w-48 flex-auto px-4 py-2">
                {{ 'housekeeping.billingConcept' | transloco }}
            </div>
            <div class="border border-primary text-primary text-center w-64 flex-none px-4 py-2">
                {{ 'housekeeping.quantity' | transloco }}
            </div>
            <div class="border border-primary text-primary text-center w-64 flex-none px-4 py-2">
                {{ 'housekeeping.type' | transloco }}
            </div>
        </div>
        @for (concept of totalByNet4Concepts.value(); track concept.net4ConceptId) {
            <div class="flex w-full">
                <div class="border w-96 flex-auto px-4 py-2">
                    {{ concept.net4ConceptName }}
                </div>
                <div class="border text-center w-64 flex-none px-4 py-2">
                    @if (concept.ratioAsTime) {
                        {{ concept.quantity }} ({{ minutesToString(concept.time) }})
                    } @else if (concept.timeAsRatio) {
                        {{ minutesToString(concept.time) }} ({{ concept.quantity }})
                    } @else if (concept.type === 'TIME') {
                        {{ minutesToString(concept.time) }}
                    } @else {
                        {{ concept.quantity }}
                    }
                </div>
                <div class="border text-center w-64 flex-none px-4 py-2">
                    @if (concept.ratioAsTime) {
                        {{ 'taskList.ratio' | transloco }} ({{ 'taskList.billedByTime' | transloco }})
                    } @else if (concept.timeAsRatio) {
                        {{ 'taskList.time' | transloco }} ({{ 'taskList.billedByRatio' | transloco }})
                    } @else if (concept.type === 'TIME') {
                        {{ 'taskList.time' | transloco }}
                    } @else if (concept.type === 'RATIO') {
                        {{ 'taskList.ratio' | transloco }}
                    } @else if (concept.type === 'BOOLEAN' && !data.isCenterPremisesType) {
                        {{ 'taskList.boolean' | transloco }}
                    } @else if (concept.type === 'BOOLEAN') {
                        {{ 'taskList.other' | transloco }}
                    } @else if (concept.type === 'NUMERIC') {
                        {{ 'taskList.numeric' | transloco }}
                    }
                </div>
            </div>
        } @empty {
            <div class="flex w-full">
                <p class="font-semibold tracking-tight leading-tight text-center px-8 py-4 w-full">{{ 'housekeeping.noMonthConcepts' | transloco }}</p>
            </div>
        }
    </div>
</div>
